import vueConfig from '../../config/vueConfig'

var adminPath = vueConfig.adminUrl;
export default {
    adminPages: [
        //#自动adminPath#
        {path: adminPath + "/contractNo", component: () => import("./contractNo_index.vue")},
    ]
}
